type TimeMap = Record<string, number | undefined>;

interface ResolveTimeSelectionParams {
  currentTime: string | null | undefined;
  displayedTimes: TimeMap | null | undefined;
  newDateTimes: TimeMap | null | undefined;
  guests: number;
  availabilityFiltered?: boolean;
}

/**
 * Decide which time value to keep or replace when dates/times change.
 * Returns the existing time if it is still present; otherwise returns the first available time.
 */
export const resolveTimeSelection = ({
  currentTime,
  displayedTimes,
  newDateTimes,
  guests,
  availabilityFiltered = true,
}: ResolveTimeSelectionParams): string | null | undefined => {
  if (!availabilityFiltered || !displayedTimes) {
    return currentTime;
  }

  const normalizedTime =
    currentTime && typeof currentTime.trim === 'function'
      ? currentTime.trim()
      : currentTime;

  const timesLoaded =
    displayedTimes && Object.keys(displayedTimes).length > 0 && !!currentTime;

  const timeAvailable =
    normalizedTime &&
    (displayedTimes[normalizedTime] !== undefined ||
      displayedTimes[currentTime as string] !== undefined);

  const missingOrInsufficient =
    newDateTimes &&
    normalizedTime &&
    (newDateTimes[normalizedTime] === undefined ||
      (newDateTimes[normalizedTime] as number) < guests);

  const shouldReplace =
    timesLoaded && !timeAvailable && newDateTimes && missingOrInsufficient;

  if (!shouldReplace) {
    return currentTime;
  }

  const fallback =
    Object.keys(displayedTimes || {}).find(
      (key) =>
        displayedTimes?.[key] !== undefined &&
        (displayedTimes?.[key] as number) >= guests
    ) || null;

  return fallback;
};
